module.exports = __webpack_public_path__ + "static/media/linux_rockchip.107154d9.png";